/* global $, APP, AccessBellMeetJS, config, interfaceConfig */

import React from 'react';
import Webcam from "react-webcam";
import { Button } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import { SETTINGS_TABS } from '../../../settings';
import {openSettingsDialog} from '../../../settings/actions';

import getRoomName from '../../../base/config/getRoomName';

import { IconMicrophone, IconMicDisabled , IconCamera, IconCameraDisabled} from '../../../base/icons';

import { AbstractWelcomePage, _mapStateToProps } from '../../../welcome/components/AbstractWelcomePage';

import { connect } from '../../../base/redux';
import { translate } from '../../../base/i18n';
import { AccessBellLogo } from '../../../base/icons';
import Spinner from 'react-activity/dist/Spinner';
// import 'react-activity/dist/Spinner.css';

import {
    PostMessageTransportBackend,
    Transport
} from '../../../../../modules/transport';

import {
    getAvailableDevices,
    getCurrentDevices,
    isDeviceChangeAvailable,
    isDeviceListAvailable,
    isMultipleAudioInputSupported,
    setAudioInputDevice,
    setAudioOutputDevice,
    setVideoInputDevice
} from '../../../../../modules/API/external/functions';

import { parseURLParams } from '../../../base/util';
// import DotLoader from "react-spinners/DotLoader";
// import { css } from "@emotion/core";

class PreConference extends AbstractWelcomePage {

    constructor(props) {
        super(props);

        var currentSelectedVideoController = localStorage.getItem('preSelectedVideoInput'); 
        var currentSelectedAudioController = localStorage.getItem('preSelectedAudioInput');

        if (currentSelectedVideoController == undefined) {
            currentSelectedVideoController = "";
        }
        
        if (currentSelectedAudioController == undefined) {
            currentSelectedAudioController = "";
        }

        localStorage.setItem("preSelectedAudioMuted", false);
        localStorage.setItem("preSelectedVideoMuted", false);
        this.state = {
            camChecked: "On",
            micChecked: "Off",
            selectedVideoController: currentSelectedVideoController,
            selectedAudioController: currentSelectedAudioController,
            availableVideoDevices: [],
            availableAudioDevices: [],
            audioMuted: true,
            videoMuted: false,
            room: getRoomName(),
            loading: false
        }

        const { scope } = parseURLParams(window.location);
        console.log(parseURLParams(window.location));
        console.log(scope, "testing........");
        this._transport = new Transport({
            backend: new PostMessageTransportBackend({
                postisOptions: {
                    scope,
                    window: window.opener
                }
            })
        });
    }

    async componentDidMount() {
        var devices = await navigator.mediaDevices.enumerateDevices();
        if (devices == undefined) {
            devices = []
        }
        var currentVideoDevices = devices.filter(device => device.kind == "videoinput");
        var currentAudioDevices = devices.filter(device => device.kind == "audioinput");
        this.setState({
            availableVideoDevices: currentVideoDevices,
            availableAudioDevices: currentAudioDevices,
            selectedVideoController: currentVideoDevices.length != 0 ? currentVideoDevices[0].deviceId : "",
            selectedAudioController: currentAudioDevices.length != 0 ? currentAudioDevices[0].deviceId : "",
            audioMuted: false
        })
    }

    handleCamera = e => {
        const camChecked = e.target.checked;
        const lightLabel = checked ? 'On' : 'Off';
        this.setState({camChecked, lightLabel});
    }

    handleMicrophone() {
        console.log("microphone");
        this.setState({micChecked: true});
    }

    /**
     * Handles clicking / pressing the button, and opens the appropriate dialog.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { defaultTab = SETTINGS_TABS.DEVICES } = this.props;
        // sendAnalytics(createToolbarEvent('settings'));
        APP.store.dispatch(openSettingsDialog(defaultTab));
    }

    _handleJoinMeeting() {
        this.setState({loading: true});
        let jsonContent = decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
        let urlGetParams = null;
        if (jsonContent != undefined && jsonContent != "") {
            urlGetParams = JSON.parse('{"' + jsonContent + '"}');
        }
        var memberId = urlGetParams['memberId'];
        console.log(memberId);
        window.memberId = memberId;
        localStorage.setItem('allowJoinMeeting', true);
        localStorage.setItem('preSelectedVideoInput', this.state.selectedVideoController);
        localStorage.setItem('preSelectedAudioInput', this.state.selectedAudioController);
        localStorage.setItem('preSelectedAudioMuted', this.state.audioMuted);
        localStorage.setItem('preSelectedVideoMuted', this.state.videoMuted);
        console.log("ready to Join meeting")
        this._onJoin();
    }

    /**
     * Sets the audio input device to the one with the id that is passed.
     *
     * @param {string} id - The id of the new device.
     * @returns {Promise}
     */
    _setAudioInputDevice(id) {
        return setAudioInputDevice(this._transport, undefined, id);
    }

    /**
     * Sets the audio output device to the one with the id that is passed.
     *
     * @param {string} id - The id of the new device.
     * @returns {Promise}
     */
    _setAudioOutputDevice(id) {
        return setAudioOutputDevice(this._transport, undefined, id);
    }

    /**
     * Sets the video input device to the one with the id that is passed.
     *
     * @param {string} id - The id of the new device.
     * @returns {Promise}
     */
    _setVideoInputDevice(id) {
        return setVideoInputDevice(this._transport, undefined, id);
    }

    _handleVideoChange = (event) => {
        this.setState({
            selectedVideoController: event.target.value
        })
    }

    _handleAudioChange = (event) => {
        this.setState({
            selectedAudioController: event.target.value
        })
    }

    _handleAudioToggle() {
        var newMutedStatus = !this.state.audioMuted;
        this.setState({
            audioMuted: newMutedStatus
        })
    }

    _handleVideoToggle() {
        // console.log(this.state.videoMuted, "video_muted");
        var newMutedStatus = !this.state.videoMuted;
        this.setState({
            videoMuted: newMutedStatus
        })
    }

    render() {
        // const override = css`
        //     margin: 0 auto;
        //     border-color: blue;
        //     display: flex;
        //     flex-direction: column;
        //     justify-content: center;
        //     align-items: center;
        //     text-align: center;
        //     position: absolute;
        //     top: 50%;
        //     left: 50%;
        //     margin-top: -50px;
        //     margin-left: -50px;
        //     `;
            
        return (
            <div style={{height: '100%', overflowY: 'scroll'}}>
            {!this.state.loading ? <div className = "inlay" style={{display: "flex", flexDirection: "column", justifyContent: "center", marginTop: "0px"}}>
                <div style={{display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: '200px'}}>
                    <AccessBellLogo />
                </div>
                <h3 className = 'inlay__title' style={{marginTop: "20px"}}>
                    You are about to enter a meeting.
                </h3>
                <div style={{display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center"}}>
                    <center>
                    <div style={{marginTop: "20px"}}>
                        { !this.state.videoMuted ?
                            <Webcam
                                audio = {!this.state.audioMuted}
                                height={"400px"}
                                width={"720px"}
                                videoConstraints={{deviceId: this.state.selectedVideoController}}
                                audioConstraints={{deviceId: this.state.selectedAudioController}}
                                style={{width: "initial", borderRadius: 10}}  
                            /> :
                                <div width={"720px"} height={"400px"} style={{backgroundColor: "lightblue", width: "600px", height: "400px", borderRadius: 10}}>
                                </div>
                        }
                    </div>
                    </center>
                    <div style={{marginTop: "20px", display: "flex", flexDirection: "row", justifyContent: "center"}}>
                        <div style={{marginRight: "20px", border: "1px solid #fff", borderRadius: "4px"}}>
                            <Button 
                                onClick={this._handleAudioToggle.bind(this)}
                                style={{width: "50px", backgroundColor: this.state.audioMuted ? "#d1dbe8" : "#fff", borderColor: this.state.audioMuted ? "#d1dbe8" : "#fff"}}
                            >
                                {
                                    this.state.audioMuted ? <IconMicDisabled style={{width: "30px", fill: "#5e6d7a"}}/> : <IconMicrophone style={{width: "30px", fill: "#5e6d7a"}}/>
                                }
                            </Button>
                        </div>
                        <div style={{border: "1px solid #fff", borderRadius: "4px"}}>
                            <Button 
                                onClick={this._handleVideoToggle.bind(this)}
                                style={{width: "50px", backgroundColor: this.state.videoMuted ? "#d1dbe8" : "#fff", borderColor: this.state.videoMuted ? "#d1dbe8" : "#fff"}}
                            >
                                {
                                    this.state.videoMuted ? <IconCameraDisabled style={{width: "30px", fill: "#5e6d7a"}}/> : <IconCamera style={{width: "30px", fill: "#5e6d7a"}}/>
                                }
                            </Button>
                        </div>
                    </div>
                    <div style={{marginTop: "20px", display: "flex", flexDirection: "row", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 100 + "%"}}>
                        <div>
                        {this.state.selectedVideoController != "" && this.state.availableVideoDevices.length > 0
                        && <FormControl style={{backgroundColor: "white", width: "200px"}}
                            >
                            <InputLabel id="video_selector">Camera</InputLabel>
                            <Select
                                labelId="video_selector"
                                id="video_selector_id"
                                value={this.state.selectedVideoController}
                                onChange={this._handleVideoChange}
                                style={{textAlign: "left", marginLeft: "5px"}}
                            >
                                {
                                    this.state.availableVideoDevices.map((device, key) => {
                                        console.log("KEY: ", key)
                                        return (
                                            <MenuItem value={device.deviceId} key={key}>
                                                {device.label}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            </FormControl>
                        }
                        </div>
                        <div style={{marginLeft: "10px"}}>
                        {this.state.selectedAudioController != "" && this.state.availableAudioDevices.length > 0
                          && <FormControl style={{backgroundColor: "white", width: "200px"}}
                            >
                            <InputLabel id="audio_selector">Audio</InputLabel>
                            <Select
                                labelId="audio_selector"
                                id="audio_selector_id"
                                value={this.state.selectedAudioController}
                                onChange={this._handleAudioChange}
                                style={{textAlign: "left", marginLeft: "5px"}}
                                >
                                {
                                    this.state.availableAudioDevices.map((device, key) => {
                                        return (
                                            <MenuItem value={device.deviceId} key={key}>
                                                {device.label}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            </FormControl>
                        }
                        </div>
                    </div>
                </div>
                
                <div style={{marginTop: "20px", display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 40 + "%"}}>
                {/* <Button variant="contained" color="default" onClick={() => {this._handleClick()}}>
                    Audio/Video Preferences
                </Button> */}
                <Button variant="contained" color="primary" onClick={() => {this._handleJoinMeeting()}} style={{marginTop: "10px"}}>
                    Join Meeting
                </Button>
                </div>
                
            </div>
                :
                <div className = "inlay" style = {{display: 'flex',  justifyContent:'center', alignItems:'center', color: 'black', zIndex: '910910910910999', fill: 'black'}}>
                    <Spinner/>
                </div> 
                }
            {/* {this.state.loading &&
                <div style = {{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                <Spinner/>
                </div>
            } */}
            {/* <div className="sweet-loading">
                <DotLoader
                css={override}
                size={150}
                color={"#123abc"}
                loading={this.state.loading}
                />
            </div> */}
            </div>
        )
    }
}

export default translate(connect(_mapStateToProps)(PreConference));